import React, { Suspense } from 'react';
import ProductsSiteLayout from './ProductsSiteLayout';
import ManageProfileSkeleton from '../../newsintelligence/MainHeader/ManageProfile/ManageProfileSkeleton';

const ManageProfile = React.lazy(() => import('../../newsintelligence/MainHeader/ManageProfile/ManageProfile'));

export default function ProductsProfilePage() {
  return (
    <ProductsSiteLayout activeNav="profile" mainClassName="products-page-main--profile">
      <div className="products-band products-profile-wrap">
        <Suspense fallback={<ManageProfileSkeleton />}>
          <ManageProfile />
        </Suspense>
      </div>
    </ProductsSiteLayout>
  );
}
